/**
 * @generated SignedSource<<8835af54b14818deb675d643a7d9959c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecordingRow_viewer$data = {
  readonly remainingMeetingRecordingCredits: number;
  readonly " $fragmentSpreads": FragmentRefs<"RecordingRowOutOfCreditsWarning_viewer">;
  readonly " $fragmentType": "RecordingRow_viewer";
};
export type RecordingRow_viewer$key = {
  readonly " $data"?: RecordingRow_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecordingRow_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecordingRow_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingMeetingRecordingCredits",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecordingRowOutOfCreditsWarning_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ae94774e20a9ffd01137236b332a6afb";

export default node;
